// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.self-publisher-songwriter .footer-block {
  display: flex;
  justify-content: flex-end;
  gap: 3.5rem;
  padding-top: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/SelfPublisherSongwriterPopup/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;AAAJ","sourcesContent":[".self-publisher-songwriter {\n  .footer-block {\n    display: flex;\n    justify-content: flex-end;\n    gap: 3.5rem;\n    padding-top: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
